import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { ChevronRight } from "lucide-react";

export function PolicyLayout({ title, updated, kicker, children }) {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <nav className="text-xs text-muted-foreground flex items-center gap-1 mb-6">
        <Link to="/" className="hover:text-primary">Home</Link>
        <ChevronRight className="w-3 h-3" />
        <span className="text-foreground">{title}</span>
      </nav>
      {kicker && <div className="section-label">{kicker}</div>}
      <h1 className="font-serif text-4xl md:text-5xl mt-2">{title}</h1>
      <div className="mt-3 text-sm text-muted-foreground">Last updated: {updated || "February 2026"}</div>
      <article className="mt-10 prose prose-neutral max-w-none [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-primary [&_h3]:font-serif [&_h3]:text-xl [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:leading-relaxed [&_p]:text-foreground/85 [&_ul]:list-disc [&_ul]:pl-6 [&_ul_li]:my-1.5 [&_a]:text-primary [&_a]:underline">
        {children}
      </article>
    </div>
  );
}

export function ConfigField({ value, label }) {
  if (value) return <span className="font-medium text-foreground">{value}</span>;
  return <span className="inline-block px-2 py-0.5 rounded bg-amber-100 text-amber-900 text-xs font-medium" data-testid="config-missing">[Please configure {label} in Admin → Settings]</span>;
}

export function useSettings() {
  const { settings } = useApp();
  return settings;
}
